export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
  MINIMAL = 'MINIMAL',
  DANGER = 'DANGER',
}
